import React from "react";
import { CgWorkAlt } from "react-icons/cg";
import { FaUniversity } from "react-icons/fa";
import { TbHomeSignal } from "react-icons/tb";
import { MdHomeWork } from "react-icons/md";

import hirehostImg from "../images/hirehost.svg";
import kaizenImg from "../images/kaizen.svg";
import learnotterImg from "../images/learnotter.png";
import petlinkImg from "../images/petlink.svg"
import sportsjawImage from "../images/sportsjaw.svg"
import raiserImage from "../images/raiser.svg"
import modtodImage from "../images/modtod.svg"
import fastfocusImage from "../images/fastfocus.svg"
// Navigation links
export const LINKS = [
  {
    name: "Home",
    hash: "#home",
  },
  {
    name: "About",
    hash: "#about",
  },
  {
    name: "Skills",
    hash: "#myskills",
  },
  {
    name: "Experience",
    hash: "#experience",
  },
  {
    name: "Projects",
    hash: "#projects",
  },
  {
    name: "Contact",
    hash: "#contact",
  },
] as const;

// External links
export const EXTRA_LINKS = {
  linkedin: "https://www.linkedin.com/in/ashishtz",
  github: "https://github.com/ashishtz",
  stackoverflow: "https://stackoverflow.com/users/8416411/ashish-patel",
  resume: "/ashishtz.pdf",
  email: "ashishtzdev@gmail.com",
} as const;

// Data for work experience
export const EXPERIENCES_DATA = [
  {
    title: "Contract Developer (Remote)",
    location: "Devdocs LLC, Texas, USA",
    description:
      "As a contract developer at Devdocs LLC in Austin, Texas, I specialize in writing comprehensive technical documentation for code and tackling intricate challenges in various projects. I am deeply involved in utilizing chatGPT APIs and other AI-related libraries, demonstrating my ability to deliver innovative solutions and drive success in complex environments.",
    icon: React.createElement(MdHomeWork),
    date: "February 2024 - Current",
  },
  {
    title: "Senior Software Developer",
    location: "Techuz Infoweb pvt.ltd, Ahmedabad, India",
    description:
      "As a Senior Software Developer, I lead by example, motivating developers to follow best practices and providing guidance to overcome challenges. I review pull requests, offer feedback, and create project boilerplates for efficiency. Additionally, I communicate with clients, addressing their requirements, and manage project timelines to ensure timely milestone delivery.",
    icon: React.createElement(CgWorkAlt),
    date: "July 2019 - February 2024",
  },
  {
    title: "Pilot Web Developer",
    location: "Creole Studios, Ahmedabad, India",
    description:
      "As a Junior Web Developer, I collaborated closely with a senior developer to grasp project requirements. I participated in code reviews to enhance my coding skills and followed web development best practices as per company standards. Troubleshooting and debugging issues in both frontend and backend code, I also assisted in maintaining and updating existing web applications. My dedication to completing tasks within provided timelines resulted in providing nearly accurate output for the given tasks.",
    icon: React.createElement(CgWorkAlt),
    date: "February 2017 - June 2019",
  },
  {
    title: "MSC IT (Masters)",
    location: "Kadi Sarva Vishwa Vidhyalaya, Gandhinagar, India",
    description:
      "Awarded a Master of Science in Information Technology (MSc IT) from Kadi Sarva Vishwavidyalaya University (KSV), a UGC-approved university in Gujarat, India. KSV is known for its focus on contemporary IT programs and fostering a research-oriented learning environment.",
    icon: React.createElement(FaUniversity),
    date: "June 2015 - June 2017",
  },
  {
    title: "BSC IT (Bachelors)",
    location: "Kadi Sarva Vishwa Vidhyalaya, Gandhinagar, India",
    description:
      "Holds a Bachelor of Science in Information Technology (BSc IT) from Kadi Sarva Vishwavidyalaya University (KSV) in Gujarat, India. KSV is a UGC-approved university known for its focus on contemporary IT education.",
    icon: React.createElement(FaUniversity),
    date: "June 2012 - June 2015",
  },
] as const;

// Data for projects
export const PROJECTS_DATA = [
  {
    title: "Hirehost",
    description:
      "Hirehost innovates job recruitment with AI-driven chatbots, enhancing efficiency and accessibility for users and employers.",
    tags: [
      "React",
      "Next.js",
      "TypeScript",
      "Node",
      "Hapi.js",
      "Python",
      "Rasa",
      "ChatGPT API",
      "Minio",
      "MySql",
      "Redis",
      "MongoDB",
    ],
    imageUrl: hirehostImg,
    projectUrl: "https://hirehost.com/",
  },
  {
    title: "Kaizen",
    description:
      "Kaizen simplifies team reviews using React, GraphQL, and ChatGPT for feedback refinement, alongside Google Workspace for user authentication and team sync.",
    tags: [
      "React",
      "Vite",
      "Graphql",
      "Apollo CLient",
      "Apollo Server",
      "Hasura",
      "ChatGPT API",
      "Google Auth",
      "Google Workspace",
      "PostgreSql",
      "AWS EC2"
    ],
    imageUrl: kaizenImg,
    projectUrl: "https://mykaizen.ai/",
  },
  {
    title: "SportsJaw",
    description:
      "SportsJaw: Web app empowering sports bettors with insights (predictions & previews). Built with React & GraphQL for a seamless experience.",
    tags: [
      "React",
      "Graphql",
      "Apollo CLient",
      "Apollo Server",
      "Hasura",
      "Express.Js",
      "PostgreSQL",
      "Docker",
      "Heroku"
    ],
    imageUrl: sportsjawImage,
    projectUrl: "https://sportsjaw.com/",
  },
  {
    title: "Learnotter",
    description:
      "LearnOtter optimizes online learning with React, Express.js, Redux for frontend-backend synergy, ensuring seamless collaboration and intuitive user experience.",
    tags: [
      "React",
      "Redux",
      "Gatsby",
      "Express.Js",
      "Socket.io",
      "Stripe",
      "Minio",
      "MySQL",
      "Nginx",
      "Docker",
      "AWS EC2"
    ],
    imageUrl: learnotterImg,
    projectUrl: "https://www.techuz.com/portfolio/learnotter/",
  },
  {
    title: "Petlink",
    description:
      "B2C pet care marketplace using Angular, Node for web, React Native for mobile, enabling seamless transactions, service bookings.",
    tags: [
      "Angular",
      "Express.Js",
      "React Native",
      "Socket.io",
      "Google Calendar",
      "MySQL",
      "Nginx",
      "Digital Ocean"
    ],
    imageUrl: petlinkImg,
    projectUrl: "https://www.techuz.com/portfolio/petlink/",
  },
  {
    title: "Raiser",
    description:
      "Streamlined training program management across 13 African countries using Laravel, Angular, AWS S3, MySQL, empowering teams and consultants.",
    tags: [
      "Php",
      "Laravel",
      "Angular",
      "AWS S3",
      "Apache2",
      "MySQL",
      "Digital Ocean"
    ],
    imageUrl: raiserImage,
    projectUrl: "https://www.creolestudios.com/our-works/raiserresourcegroup/",
  },
  {
    title: "Modtod",
    description:
      "Canadian ecommerce app for pre-owned children's items. Uses Angular, Lumen, React Native, AWS S3, Canada Post API for hassle-free transactions.",
    tags: [
      "Php",
      "Lumen",
      "Angular",
      "React Native",
      "Canada Post API",
      "Apache2",
      "MySQL",
      "Digital Ocean"
    ],
    imageUrl: modtodImage,
    projectUrl: "https://www.creolestudios.com/our-works/modtod/",
  },
  {
    title: "Fastfocus",
    description:
      "FastFocus redefines market research with dynamic surveys using React, AWS, and Google Auth, enabling real-time feedback for informed decisions.",
    tags: [
      "React",
      "Redux",
      "AWS Lambda",
      "AWS S3",
      "AWS Cloudfront",
      "Google Auth"
    ],
    imageUrl: fastfocusImage,
    projectUrl: "https://www.creolestudios.com/our-works/fastfocus/",
  },
] as const;

// Data for skills
export const SKILLS_DATA = [
  // Foundational Web Technologies
  "HTML5",
  "CSS3",
  "JavaScript",

  // Advanced JavaScript & Front-end Frameworks/Libraries
  "TypeScript",
  "React",
  "Angular",
  "Next.js",
  "Gatsby.js",
  "Remix.run",
  "Redux",
  "Apollo Client",
  "Framer Motion",

  // CSS Frameworks & UI Libraries
  "Tailwind",
  "Bootstrap",
  "Material UI",
  "Ant Design",
  "Semantic UI",

  // Back-end Technologies & Frameworks
  "Node.js",
  "Express",
  "Hapi.js",
  "Django",
  "Flask",
  "Laravel",
  "Apollo Server",

  // Database Technologies
  "PostgreSQL",
  "MySql",
  "MongoDb",
  "DynamoDb",
  "Firestore",
  "Redis",

  // ORM & Query Builders
  "Prisma",
  "Sequelize",
  "Mongoose",
  "TypeORM",
  "Eloquent ORM",
  "Objection.js",

  // GraphQL Ecosystem
  "GraphQL",
  "Apollo", 

  // DevOps & Deployment
  "Docker",
  "Jenkins",
  "AWS S3",
  "AWS EC2",
  "AWS Comprehend",
  "Nginx",
  "Apache2",
  
  // Version Control
  "Git",
  
  // Chatbot Framework
  "Rasa",
  "Markprompt",,
  "ChatGPT API",

  // Additional Tools
  "Lerna", // Monorepo Management
  
  // Server-Side Rendering
  "SSR",

  // Soft Skills
  "Team player",
  "Strong problem solver",
  "Good time management",
] as const;



// Owner name
export const OWNER_NAME = "Ashish Patel";
